<script>
export default {
    name: 'IconGeoloc',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-geoloc"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M35 8v4.224c8.644 1.3 15.476 8.132 16.777 16.776H56v6h-4.224c-1.3 8.644-8.132 15.476-16.775 16.776L35 56h-6v-4.223c-8.644-1.3-15.476-8.133-16.776-16.776L8 35v-6h4.223c1.3-8.644 8.133-15.476 16.777-16.777V8h6zm-3 10c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14-6.268-14-14-14zm0 9a5 5 0 110 10 5 5 0 010-10z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
